/* ===== Aevorix Shopify theme JS ===== */
(function () {
  const $ = (s, r = document) => r.querySelector(s);
  const $$ = (s, r = document) => Array.from(r.querySelectorAll(s));
  const money = c => "₹" + (c / 100).toLocaleString("en-IN", { minimumFractionDigits: 0, maximumFractionDigits: 2 });

  let toastT;
  function toast(m) { const t = $("#toast"); if (!t) return; t.textContent = m; t.classList.add("show"); clearTimeout(toastT); toastT = setTimeout(() => t.classList.remove("show"), 2200); }

  /* ---- drawer ---- */
  function openCart() { $("#cartDrawer")?.classList.add("open"); $("#cartOverlay")?.classList.add("open"); }
  function closeCart() { $("#cartDrawer")?.classList.remove("open"); $("#cartOverlay")?.classList.remove("open"); }

  /* ---- render cart ---- */
  async function refreshCart(openAfter) {
    const cart = await fetch("/cart.js").then(r => r.json());
    const badge = $("#cartCount");
    if (badge) { badge.textContent = cart.item_count; badge.style.display = cart.item_count ? "grid" : "none"; }
    const box = $("#cartItems");
    if (box) {
      if (!cart.items.length) {
        box.innerHTML = '<div class="cart-empty">Your cart is empty.<br>Add something great 👇</div>';
        $("#cartFoot") && ($("#cartFoot").style.display = "none");
      } else {
        box.innerHTML = cart.items.map(it => `
          <div class="line">
            <img src="${it.image ? it.image.replace(/(\.[a-z]+)(\?.*)?$/i, '_120x$1') : ''}" alt="">
            <div class="info">
              <h4>${it.product_title}</h4>
              ${it.variant_title && it.variant_title !== 'Default Title' ? `<div class="p">${it.variant_title}</div>` : ''}
              <div class="p">${money(it.final_price)}</div>
              <div class="qty" style="margin-top:6px">
                <button data-key="${it.key}" data-q="${it.quantity - 1}">−</button>
                <input value="${it.quantity}" readonly style="width:34px">
                <button data-key="${it.key}" data-q="${it.quantity + 1}">+</button>
              </div>
            </div>
            <div style="text-align:right">
              <div style="font-weight:700">${money(it.final_line_price)}</div>
              <button class="rm" data-key="${it.key}" data-q="0">remove</button>
            </div>
          </div>`).join("");
        $("#cartFoot") && ($("#cartFoot").style.display = "block");
        $("#cartSubtotal") && ($("#cartSubtotal").textContent = money(cart.total_price));
      }
      box.querySelectorAll("[data-key]").forEach(b =>
        b.addEventListener("click", () => changeQty(b.dataset.key, +b.dataset.q)));
    }
    if (openAfter) openCart();
  }

  async function changeQty(key, qty) {
    await fetch("/cart/change.js", { method: "POST", headers: { "Content-Type": "application/json" }, body: JSON.stringify({ id: key, quantity: qty }) });
    refreshCart(false);
  }

  async function addToCart(id, qty) {
    try {
      const r = await fetch("/cart/add.js", { method: "POST", headers: { "Content-Type": "application/json" }, body: JSON.stringify({ id: id, quantity: qty || 1 }) });
      if (!r.ok) { const e = await r.json(); toast(e.description || "Could not add"); return false; }
      toast("Added to cart"); refreshCart(true); return true;
    } catch (e) { toast("Could not add to cart"); return false; }
  }

  /* ---- product page: gallery + variants + block-based buy buttons ---- */
  function initProduct() {
    const root = $("#pdpRoot"); if (!root) return;

    // gallery thumbnails
    const main = $("#pdpMainImg");
    $$(".thumbs img", root).forEach(t => t.addEventListener("click", () => {
      if (main) main.src = t.dataset.full || t.src;
      $$(".thumbs img", root).forEach(x => x.classList.remove("sel")); t.classList.add("sel");
    }));

    const variants = window.__AEVORIX_VARIANTS || [];
    const select = $("#variantSelect", root);
    const priceNow = $("#pdpPriceNow", root), priceWas = $("#pdpPriceWas", root), priceOff = $("#pdpPriceOff", root);

    function currentVariant() {
      const vid = select ? select.value : root.dataset.variant;
      return variants.find(x => String(x.id) === String(vid)) || variants[0];
    }
    function syncVariant() {
      const v = currentVariant(); if (!v) return;
      root.dataset.variant = v.id;
      // keep every buy form (add-to-cart, buy-now, and app forms) pointed at the chosen variant
      $$(".pdp-variant-id", root).forEach(i => i.value = v.id);
      if (priceNow) priceNow.textContent = money(v.price);
      if (priceWas) { if (v.compare_at_price && v.compare_at_price > v.price) { priceWas.textContent = money(v.compare_at_price); priceWas.style.display = ""; } else priceWas.style.display = "none"; }
      if (priceOff) { if (v.compare_at_price && v.compare_at_price > v.price) { priceOff.textContent = "-" + Math.round((1 - v.price / v.compare_at_price) * 100) + "%"; priceOff.style.display = ""; } else priceOff.style.display = "none"; }
      $$(".pdp-add", root).forEach(b => { b.disabled = !v.available; b.textContent = v.available ? (b.dataset.label || b.textContent) : "Sold out"; });
    }
    select && select.addEventListener("change", syncVariant);
    syncVariant();

    // quantity +/- (inside the add-to-cart block)
    $$(".qty button", root).forEach(b => b.addEventListener("click", () => {
      const q = $(".pdp-qty-input", b.closest(".qty-row") || root);
      if (!q) return;
      q.value = Math.max(1, parseInt(q.value || "1", 10) + (+b.dataset.d));
    }));

    // AJAX add-to-cart (progressive enhancement; native submit still works if JS fails)
    const atc = $(".pdp-atc-form", root);
    if (atc) atc.addEventListener("submit", e => {
      e.preventDefault();
      const id = ($(".pdp-variant-id", atc) || {}).value || root.dataset.variant;
      const qty = parseInt(($(".pdp-qty-input", atc) || {}).value || "1", 10);
      addToCart(id, qty);
    });
    // Buy Now (online payment) → add current variant, go straight to Shopify checkout
    $(".pdp-buynow", root)?.addEventListener("click", async () => {
      const id = root.dataset.variant;
      const qty = parseInt(($(".pdp-qty-input", root) || {}).value || "1", 10);
      try {
        const r = await fetch("/cart/add.js", { method: "POST", headers: { "Content-Type": "application/json" }, body: JSON.stringify({ id: id, quantity: qty }) });
        if (r.ok) { window.location.href = "/checkout"; } else { const e = await r.json(); toast(e.description || "Could not proceed"); }
      } catch (e) { toast("Could not proceed"); }
    });
    // Releasit COD app form submits natively — left untouched on purpose
  }

  /* ---- grid add-to-cart buttons ---- */
  function initGrid() {
    $$("[data-add-variant]").forEach(b => b.addEventListener("click", e => {
      e.preventDefault(); addToCart(b.dataset.addVariant, 1);
    }));
  }

  function init() {
    $("#openCart")?.addEventListener("click", openCart);
    $("#closeCart")?.addEventListener("click", closeCart);
    $("#cartOverlay")?.addEventListener("click", closeCart);
    refreshCart(false);
    initProduct();
    initGrid();
  }
  document.addEventListener("DOMContentLoaded", init);
})();
